module.exports = __webpack_public_path__ + "img/65702.b8bc780b.png";